import { PaperRollOutlineIcon } from './PaperRollOutlineIcon';

/**
 * author: Simran
 * id 2A7CBB78-4672-450C-8578-48AFB13243CD
 * name paper-roll-outline
 * version: 4.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/paper-roll-outline.svg
 * tags
 * - Home Automation 
 * - Printer 
 */
export const BathroomTissueOutlineIcon = PaperRollOutlineIcon;
export default BathroomTissueOutlineIcon